import yup from '../../Utils/yup';

export const createCompanyFormRules = yup.object().shape({
  name: yup.string().required(),
  logoUrl: yup.string().required()
});
